import React from 'react';
import ReactDOMServer from 'react-dom/server';

const styles = {
	WitMegEmail: {
		maxWidth: '600px',
		padding: '100px 75px',
		fontSize: '15px',
	},

	// Header
	WitMegEmail__header: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: '40px',
	},
	WitMegEmail__header__img: {
		maxWidth: '200px',
	},

	// Body
	WitMegEmail__body: {},

	WitMegEmail__body__p: {
		marginBottom: '15px',
	},

	WitMegEmail__body__p___attention: {
		margin: '25px auto',
		textAlign: 'center',
		fontWeight: 'bold',
		fontSize: '20px',
	},

	WitMegEmail__body__p___salutation: {
		marginTop: '50px',
	},

	// Footer
	WitMegEmail__footer: {
		marginTop: '50px',
		textAlign: 'center',
		background: '#e8e8e8',
		padding: '10px',
	},
};

export const SignupCompleteEmailTemplate = (props) => {
	const { emailData = {} } = props;
	const { userName = '' } = emailData;
	const year = new Date().getFullYear();

	return (
		<div style={styles.WitMegEmail}>
			<div style={styles.WitMegEmail__header}>
				<img
					className='WitMegEmail__header__img'
					style={styles.WitMegEmail__header__img}
					src='https://cdn.neurolage.com/ecologital/witmeg_logo.png'
					alt=''
				/>
			</div>
			<div style={styles.WitMegEmail__body}>
				<p style={styles.WitMegEmail__body__p}>Dear {userName},</p>

				<p style={styles.WitMegEmail__body__p}>
					Thank you for registering with Witmeg Loyalty. You will receive lot of
					benefits from our partners and will be rewarded with Discounts,
					Coupons, Vouchers, etc...
				</p>

				<p style={styles.WitMegEmail__body__p}>
					More and more purchases with our partners, you will get more and more
					benefits.
				</p>

				<p
					style={{
						...styles.WitMegEmail__body__p,
						...styles.WitMegEmail__body__p___attention,
					}}>
					Lets Enjoy Shopping !!!
				</p>

				<p
					style={{
						...styles.WitMegEmail__body__p,
						...styles.WitMegEmail__body__p___salutation,
					}}>
					Witmeg Loyalty
				</p>
			</div>

			<div style={styles.WitMegEmail__footer}>
				Copyright &#169; {year} Witmeg | All Rights Reserved
			</div>
		</div>
	);
};

export function generateSignupCompleteEmail(emailData = {}) {
	return ReactDOMServer.renderToStaticMarkup(
		<SignupCompleteEmailTemplate emailData={emailData} />,
	);
}
